import { Link, useLocation } from "react-router-dom";

export default function Nav() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <header
      data-testid="site-nav"
      className="sticky top-0 z-50 bg-glass backdrop-blur-xl border-b border-subtle"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 h-16 md:h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo-link"
          className="flex items-center gap-2 group"
        >
          <span
            aria-hidden="true"
            className="w-6 h-6 rounded-md border border-strong flex items-center justify-center"
            style={{ background: "var(--surface)" }}
          >
            <span
              className="block w-2 h-2 rounded-[2px]"
              style={{ background: "var(--accent)" }}
            />
          </span>
          <span className="font-display text-primary font-medium tracking-tight text-[15px] md:text-base">
            Scale Architect Labs
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 font-mono text-[11px] uppercase tracking-[0.2em] text-tertiary">
          <Link
            to="/notion"
            data-testid="nav-link-notion"
            className="hover:text-primary transition-colors"
          >
            Notion
          </Link>
          <Link
            to="/automation"
            data-testid="nav-link-automation"
            className="hover:text-primary transition-colors"
          >
            Automation
          </Link>
          <Link
            to="/stack"
            data-testid="nav-link-stack"
            className="hover:text-primary transition-colors"
          >
            AI Stack
          </Link>
        </nav>

        {!isHome && (
          <Link
            to="/"
            data-testid="nav-cta-home"
            className="font-mono text-[11px] uppercase tracking-[0.2em] text-primary border border-strong rounded-full px-4 py-2 hover:border-[var(--accent)] transition-colors"
          >
            ← Lab
          </Link>
        )}
      </div>
    </header>
  );
}
